export default "__VITE_PUBLIC_ASSET__2e85d664__"